import React from 'react';

import cn from 'classnames';
import { MdCheckCircle } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';

import { OfflineTooltip, S } from '@shared/components';
import type { UserOrganizationInfo } from '@user/types';

import parentStyles from '../../RolePickerRole.less';
import styles from './RolePickerBaseRole.less';

const stopPropagation = (e: MouseEvent) => e.stopPropagation();
const noop = () => {};

export interface RolePickerBaseRoleProps {
  children?: React.ReactNode;
  active: boolean;
  disabled?: boolean;
  org: UserOrganizationInfo;
  className?: string;
  onProfileChange: (organizationGuid: string) => void;
}

const RolePickerBaseRole: React.FC<RolePickerBaseRoleProps> = ({
  active,
  disabled,
  org,
  children,
  className,
  onProfileChange,
}) => (
  <OfflineTooltip
    disabled={!disabled}
    onClick={disabled ? stopPropagation : noop}
  >
    {active && (
      <S size="4" className={styles.currentLabel}>
        <FormattedMessage id="context.RolePicker.currentLabel" />
      </S>
    )}
    <li
      className={cn(
        styles.item,
        {
          [parentStyles.active]: active,
          [parentStyles.disabled]: disabled,
        },
        className,
      )}
      onClick={() => !disabled && onProfileChange(org.organizationGuid)}
    >
      {children}
      {active && <MdCheckCircle className={parentStyles.activeIcon} />}
    </li>
  </OfflineTooltip>
);

export default RolePickerBaseRole;
